import { render, staticRenderFns } from "./UpdateItem.vue?vue&type=template&id=6920a440&scoped=true"
import script from "./UpdateItem.vue?vue&type=script&lang=js"
export * from "./UpdateItem.vue?vue&type=script&lang=js"
import style0 from "./UpdateItem.vue?vue&type=style&index=0&id=6920a440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6920a440",
  null
  
)

export default component.exports